import React, {useState, useEffect} from 'react'
import * as DocumentApi from '../../api/archibus/DocumentApi'
import {getPlaceHolderImage, getIconUrl} from '../../utils/helpers'
import styled from 'styled-components'

const Avatar = props => {
  const [url, setUrl] = useState(props.url)
  const alt = props.alt ? props.alt : ''

  const {table, keys, docField, docFile, type, large, circle} = props

  useEffect(() => {
    if (!url && docFile) {
      DocumentApi.getTempDocumentUrl(table, keys, docField).then(url => {
        setUrl(url)
      })
    }
  })

  let iconUrl = getIconUrl(url) || getPlaceHolderImage(type)

  // Note: The image will not be rendered if the backgroundImage URL contains a
  // single apostrophe.
  /*let backgroundImage = iconUrl
    ? `url(${iconUrl})`
    : `url(${getPlaceHolderImage(type)})`*/

  return <StyledAvatar alt={alt} large={large} src={iconUrl} circle={circle} />
}

export default Avatar

Avatar.defaultProps = {
  url: null,
  table: null,
  keys: null,
  docField: null,
  docFile: null,
  large: false,
  type: 'employee',
  circle: false
}

const StyledAvatar = styled.img.attrs(({large, circle}) => {
  let height = large ? '50px;' : '30px;'
  let width = large ? '50px;' : '30px;'
  let borderRadius = '6px;'

  if (large && circle) {
    height = '54px;'
    width = '54px;'
  }

  if (circle) {
    borderRadius = '50%;'
  }

  return {
    height: height,
    width: width,
    borderRadius: borderRadius
  }
})`
  height: ${props => props.height}
  width: ${props => props.width}
  border: 1px solid #e8e9ec;
  border-radius: ${props => props.borderRadius}
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
`
